module.exports = __webpack_public_path__ + "media/images/slider-arrow-r@2x-86844e9409f08e146ede9674829eb11c.png";